import React from 'react';

const TODAY = new Date().toISOString().slice(0, 10);

function addDays(dateStr, n) {
	const d = new Date(dateStr + 'T00:00:00');
	d.setDate(d.getDate() + n);
	return d.toISOString().slice(0, 10);
}

function formatDate(dateStr) {
	const d = new Date(dateStr + 'T00:00:00');
	return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

const WINDOW = [-2, -1, 0, 1, 2].map(n => addDays(TODAY, n));

export default function ShipByDateChart({ data, selectedDate, onSelectDate }) {
	const countByDate = Object.fromEntries(data.filter(d => d.date != null).map(d => [d.date.slice(0, 10), d.count]));

	const windowData = WINDOW.map(date => ({ date, count: countByDate[date] ? countByDate[date] : 0 }));
	const maxVal = Math.max(...windowData.map(d => d.count), 1);

	const chartH = 140;
	const barW = 36;
	const gap = 12;
	const padL = 12;
	const padT = 32;
	const padB = 32;
	const totalW = padL + windowData.length * (barW + gap) - gap + padL;

	return (
		<div className="ship-date-card">
			<div className="ship-date-card__header">
				<span className="ship-date-card__title">Ship By Date</span>
			</div>

			<div style={{ overflowX: 'auto' }}>
				<svg width={totalW} height={chartH + padT + padB} style={{ display: 'block', minWidth: '100%' }}>
					{[0, 0.5, 1].map(pct => {
						const y = padT + chartH - pct * chartH;
						return (
							<line
								key={pct}
								x1={0}
								y1={y}
								x2={totalW}
								y2={y}
								stroke="#e4e8ed"
								strokeWidth="1"
								strokeDasharray="4 3"
							/>
						);
					})}

					{windowData.map((d, i) => {
						const x = padL + i * (barW + gap);
						const barH = Math.max((d.count / maxVal) * chartH, 2);
						const y = padT + chartH - barH;
						const isToday = d.date === TODAY;
						const isSelected = d.date === selectedDate;
						const isActive = isSelected || (!selectedDate && isToday);

						return (
							<g
								key={d.date}
								style={{ cursor: 'pointer' }}
								onClick={() => onSelectDate && onSelectDate(isSelected ? null : d.date)}
							>
								{(isToday || isSelected) && (
									<rect
										x={x - 6}
										y={padT}
										width={barW + 12}
										height={chartH}
										fill={isSelected && !isToday ? '#e8f0fb' : '#e8f7f4'}
										rx="6"
									/>
								)}
								<rect x={x} y={y} width={barW} height={barH} rx="4" ry="4" fill={isActive ? '#2ec4a5' : '#a8e6da'} />
								<text
									x={x + barW / 2}
									y={y - 6}
									textAnchor="middle"
									fontSize="11"
									fontWeight="600"
									fill="#1a2332"
									fontFamily="Inter, sans-serif"
								>
									{d.count}
								</text>
								<text
									x={x + barW / 2}
									y={padT + chartH + 18}
									textAnchor="middle"
									fontSize="10"
									fontWeight={isActive ? '600' : '400'}
									fill={isActive ? '#2ec4a5' : '#7a8899'}
									fontFamily="Inter, sans-serif"
								>
									{formatDate(d.date)}
								</text>
							</g>
						);
					})}
				</svg>
			</div>
		</div>
	);
}
